// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_bambu_led_cap/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_bambu_led_cap: ModuleSchema = {
  "id": "core_bambu_led_cap",
  "uniqueId": "B3D_F54MA",
  "createdAt": "2026-10-02T05:13:23.834Z",
  "updatedAt": "2026-10-28T14:58:30.755Z",
  "label": "Bambu LED Cap",
  "description": "Template starting structure for creating new 3D parametric modules",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_CAP"
  ],
  "sliders": [
    {
      "key": "ledRingOuterDia",
      "label": "Mating Thread Nominal Dia (M65)",
      "min": 50,
      "max": 80,
      "default": 65,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "ledCapLipDia",
      "label": "Retaining Lip Inner Dia",
      "min": 40,
      "max": 70,
      "default": 56,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "ledCapH",
      "label": "Cap Total Height",
      "min": 6,
      "max": 20,
      "default": 10,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "ledCapLipThick",
      "label": "Retaining Lip Thickness",
      "min": 0.5,
      "max": 3,
      "default": 1,
      "step": 0.25,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "cap_ring",
      "label": "LED Lock Ring Cap",
      "default": "#D97706",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "cap_obj",
      "label": "Bambu LED Retention Cap Ring",
      "name": "Bambu LED Retention Cap Ring",
      "color": "#D97706",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "cap_ring",
          "label": "LED Lock Ring Cap",
          "name": "LED Lock Ring Cap",
          "groupId": 0,
          "colorKey": "cap_ring",
          "defaultColor": "#D97706",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "LED Lock Cap",
      "groupId": -1
    }
  ]
};
